// Package Imports
import { z } from 'zod'

// Core Imports
import { adminListSearchSchema } from '@/core/lib/table-search-schema'

export const categorySearchSchema = adminListSearchSchema

export const createCategorySchema = z.object({
  name: z
    .string()
    .min(2, { message: 'En az 2 karakter olmalı.' })
    .max(64, { message: 'En fazla 64 karakter olabilir.' }),
  description: z
    .string()
    .max(512, { message: 'En fazla 512 karakter olabilir.' })
    .optional()
    .or(z.literal('')),
  is_public: z.boolean(),
  parent_id: z.string().optional(),
})

export const editCategorySchema = z.object({
  name: z
    .string()
    .min(2, { message: 'En az 2 karakter olmalı.' })
    .max(64, { message: 'En fazla 64 karakter olabilir.' })
    .optional(),
  description: z
    .string()
    .max(512, { message: 'En fazla 512 karakter olabilir.' })
    .optional()
    .or(z.literal('')),
  is_public: z.boolean().optional(),
})

export type TCreateCategoryFormSchema = z.infer<typeof createCategorySchema>
export type TEditCategoryFormSchema = z.infer<typeof editCategorySchema>
